import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { ParticipantsComponent } from "../../components/participants"

export const ParticipantsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <ParticipantsComponent />
    </DefaultPageComp>
  </>
}